/*=============================================== InputContainer ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
import { P, Small } from "./Font";
/*==================== Component ====================*/
var InputContainer = function (_a) {
    var label = _a.label, helper = _a.helper, helperBottom = _a.helperBottom, counter = _a.counter, maxLength = _a.maxLength, value = _a.value, children = _a.children, id = _a.id;
    return (React.createElement(Container, null,
        label && React.createElement(Label, { htmlFor: id }, label),
        helper && React.createElement(P, null, helper),
        children,
        helperBottom && React.createElement(Small, null, helperBottom),
        counter && typeof value === "string" && (React.createElement(Small, { color: "gray-500" },
            value.length,
            maxLength ? " / ".concat(maxLength) : ""))));
};
export default InputContainer;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), Mixins.Grid({
    $gap: "xxs",
}));
var Label = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: ", ";\n"], ["\n    color: ", ";\n    font-weight: ", ";\n"])), Variables.Colors.Primary500, Variables.FontWeights.Black);
var templateObject_1, templateObject_2;
